import { createApp } from "vue";
import App from "./App.vue";
import BootstrapVue3 from "bootstrap-vue-3";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";
import { Form, Field, ErrorMessage } from "vee-validate";
import { createPinia } from "pinia";
import router from "./router"; // Import the router
import "bootstrap-icons/font/bootstrap-icons.css";
const app = createApp(App);
const pinia = createPinia();
// Register vee-validate components with multi-word names
app.component("VeeForm", Form);
app.component("VeeField", Field);
app.component("VeeErrorMessage", ErrorMessage);
app.use(router); // Use Vue Router
app.use(pinia);
app.use(BootstrapVue3);
app.mount("#app");
